import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IConfigurationClinicDetailsResponseData } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
export const useConfigurationClinicDetailAPI = () => {
  const [clinicDetails, setClinicDetails] = useState<IConfigurationClinicDetailsResponseData | null>(null);
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (clinicId: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        if (!clinicId) {
          return;
        }

        const url = `${CONFIGURATION_APIS?.CLINIC_DETAIL?.baseURL}${clinicId}/`;

        const response = await axios.get(url, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        });

        const { data } = response;

        if (data.status === true) {
          setClinicDetails(data.data);
        } else {
          toast.error("Error while fetching clinic details.");
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          sendCurl(axiosError.config["curlCommand"]);
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching clinic details.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return { clinicDetails, execute };
};
